import tippy, { hideAll } from 'tippy.js';

const externalLinks = document.querySelectorAll('.js-link-external');

console.log(externalLinks)

externalLinks.forEach(($el) => {
  $el.addEventListener('click', (e) => {e.preventDefault()})

  const href = $el.getAttribute('href');
  const target = $el.getAttribute('target');
  const title = $el.getAttribute('title');
  const tooltipHeadline = '<h4><strong>Datenschschutzhinweis</strong></h4>';
  const tooltipContent = '<p><small>Sie haben gerade auf die Verlinkung zu einem externen Angebot geklickt. Damit verlassen Sie die Internetseite des Unabhängigen Beauftragten für Fragen des sexuellen Kindesmissbrauchs. Wenn Sie Dienste dieses Anbieters nutzen oder von ihm bereitgestellte Inhalte aufrufen, kann es sein, dass der Anbieter Nutzungsdaten erfasst und gegebenenfalls in Serverprotokollen speichert. Auf Art und Umfang der übertragenen bzw. gespeicherten Daten hat der Unabhängige Beauftragte für Fragen des sexuellen Kindesmissbrauchs keinen Einfluss.</small></p>';
  const tooltipLink = `<a href="${href}" target="${target}" title="${title}" class="a-button a-button--primary">Weiter zum Podcast</a>`;

  tippy($el, {
    trigger: 'click',
    theme: 'light',
    allowHTML: true,
    interactive: true,
    content: `<div class="tippy-box__link-external-info">${tooltipHeadline} ${tooltipContent} ${tooltipLink}</div>`,
  });

});


window.document.querySelectorAll('[href="#"]').forEach(($el) => {
  $el.addEventListener('click', (e) => {
    e.preventDefault();
  })
});
